import { useQuery } from "react-query";
import { getBookAuthors } from "../../services/library/bookAuthor";
import { key_bookAuthors } from "../../utils/constants";
import { PagedRequestType } from "../../types/PagedResults";

export const useGetBookAuthorsQuery = (data: PagedRequestType, options: any = null) =>
    useQuery(
        [key_bookAuthors, JSON.stringify(data)],
        () => getBookAuthors(data),
        options ? { ...options } : {}
    );
